import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { useTranslation } from 'react-i18next';

export interface EmspBoInvoiceTypeFilterStateControllerProps {
  value: EmspUserInvoiceBaseModel['type'];
  onRemove: FilteredItemProps['onRemove'];
}

export const EmspBoInvoiceTypeFilterStateController = ({
  value,
  onRemove,
}: EmspBoInvoiceTypeFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon="file-05"
      label={t(`delmonicos-shared-sdk.enums-invoice-type.${value}`)}
      onRemove={onRemove}
    />
  );
};
